import Login from '@/views/login/Index'
import { noAuthRoute } from '@/router/guards/auth'

export default {
  path: '/',
  name: 'login',
  component: Login,
  meta: {
    noAuth: true
  },
  beforeEnter (to, from, next) {
    const canEnter = noAuthRoute()
    if (canEnter) {
      return next(true)
    }
    next('/main')
  }
}
